export const REQUEST_CREATE_REASON_LOADING = "REQUEST_CREATE_REASON_LOADING";
export const REQUEST_CREATE_REASON_SUCCESS = "REQUEST_CREATE_REASON_SUCCESS";
export const REQUEST_CREATE_REASON_FAIL = "REQUEST_CREATE_REASON_FAIL";

export const FORM_CREATE_REASON = {
  REQUEST_CREATE_REASON_LOADING,
  REQUEST_CREATE_REASON_SUCCESS,
  REQUEST_CREATE_REASON_FAIL,
};
